import {CSSProperties, useMemo} from "react";
import DOMPurify from 'dompurify';
import "react-quill-new/dist/quill.core.css";
import styled from "@emotion/styled";
import {D} from "../../Constants";

export const SanitizedHtml = ({html, style, noStyles}: {
  html: string,
  style?: CSSProperties,
  className?: string,
  noStyles?: boolean
}) => {
  const clean = useMemo(() => {
    // Replace nbsp variants with regular spaces for proper wrapping
    const withSpaces = html
      .replace(/&nbsp;/gi, ' ')
      .replace(/\u00A0/g, ' ');
    return DOMPurify.sanitize(withSpaces, {
      ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'hr', 'ul', 'ol', 'li', 'a', 'b', 'i', 'u', 's', 'strong', 'em', 'strike', 'span', 'div', 'img', 'blockquote', 'pre', 'code'],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'width', 'height', 'style', 'class'],
    });
  }, [html]);
  return (
    <Container
      className={noStyles ? undefined : 'ql-editor'}
      style={noStyles ? {display: 'contents'} : {
        padding: 0,
        margin: 0,
        height: 'auto',
        ...style
      }}
      dangerouslySetInnerHTML={{__html: clean}}
    />
  );
};

const Container = styled.div`
    * {
        margin-block: ${D.unit(0.5)};
    }
    p:empty, p:has(br:only-child) {
        min-height: 1em;
    }
    p:empty::before {
        content: '';
        display: inline-block;
    }

    /* Quill's .ql-editor css hides native list markers and draws them from .ql-ui spans, which the
       saved (semantic) html doesn't have. Doubled class beats .ql-editor li / li[data-list]. */
    && ul, && ol {
        padding-left: 1.5em;
    }
    && li {
        padding-left: ${D.unit(0.5)};
        margin-block: ${D.unit(0.25)};
    }
    && ul > li, && li[data-list=bullet] {
        list-style-type: disc;
    }
    && ol > li, && li[data-list=ordered] {
        list-style-type: decimal;
    }
    && li ul > li {
        list-style-type: circle;
    }
    && li ol > li {
        list-style-type: lower-alpha;
    }
    && .ql-ui {
        display: none;
    }
    && img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: ${D.radius(0.5)};
    }
`;